/**
 * Import required libraries
 */
import React from "react";

/**
 * Import required elements
 */
// Material-ui components
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";

/**
 * Alert Component
 */
const Alert = props => {
  let {
    open = false,
    title,
    text,
    content = null,
    actions
  } = props;
  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {title ? <DialogTitle id="alert-dialog-title">{title}</DialogTitle> : null}
      <DialogContent>
        {text ?
          <DialogContentText id="alert-dialog-description">
            {text}
          </DialogContentText>
          : null
        }
        {content}
      </DialogContent>
      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </Dialog>
  );
};

export default Alert;
